<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import General from '@/services/General';
import Customers from '@/services/Customers';
import Swal from "sweetalert2";
import modalAddGiveawayPopup from '@/components/modals/app/modalAddGiveawayPopup';
import modalEditGiveawayPopup from '@/components/modals/app/modalEditGiveawayPopup';
import modalHypePopUpPhotos from '@/components/modals/app/modalHypePopUpPhotos';
import modalPreviewGiveawayPopup from '@/components/modals/app/modalPreviewGiveawayPopup';
import {tableData} from "../tables/dataAdvancedtable";

export default {
  components: { Layout, PageHeader, modalAddGiveawayPopup, modalEditGiveawayPopup, modalHypePopUpPhotos, modalPreviewGiveawayPopup },
  page: {
    title: "Application Giveaway Popup",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "Giveaway Popup",
      items: [
        {
          text: "Application",
          href: "/app",
        },
        {
          text: "Giveaway Popup",
          active: true,
        },
      ],
      isBusy: false,
      error: null,
      showModal: false,
      modalData: {},
      link_id: null,
      tableData: [],
      groups: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "date_from",
      sortDesc: true,
      fields: [
        {
          key: "name",
          label: "Name",
          sortable: false,
        },
        {
          key: "title",
          label: "Title",
          sortable: false,
        },
        {
          key: "background_image",
          label: "Image",
          sortable: false,
        },

        {
          key: "bottom_text",
          label: "Text",
          sortable: false,
        },
        {
          key: "action",
          label: "Action",
          sortable: true,
        },

        // {
        //     key: "action_text",
        //     label: "Action Text",
        //     sortable: true,
        // },
        {
          key: "type",
          label: "Type",
          sortable: false,
        },
        {
          key:"show_section",
          label:"Section",
          sortable: false,
        },
        {
          key: "participation_agreement_text",
          label: "Participation Agreement Text",
          sortable: false,
        },
        {
          key: "participation_tnc_url",
          label: "Participation Tnc Url",
          sortable: false,
        },
        {
          key: "recipient",
          label: "Recipient",
          sortable: true,
        },
        {
          key: "date_from",
          label: "Date From",
          sortable: true,
          sortDirection: 'desc'

        },
        {
          key: "date_to",
          label: "Date To",
          sortable: true,
        },
        {
          key: "success_page",
          label: "Success Page",
          sortable: false,
        },
        "actions",
      ],
      successModalVisible: false,
      successModalData: null,
    };
  },
  async created() {
    await this.getHypePopUp()
    this.fetchGroups()
  },
  methods: {
    modalAddHypePopUp() {
      this.$bvModal.show("add_new_giveaway_popup")
    },
    callModalEditGiveawayPopup(item) {
      this.$bvModal.show("edit_giveaway_popup")
      this.modalData = item
    },
    callmodalHypePopUpPhotos(item) {
      this.$bvModal.show("hype_popup_photos")
      this.modalData = item
    },
    callModalPreviewGiveawayPopup(item) {
      this.$bvModal.show("preview_giveaway_popup")
      this.modalData = item
    },
    async getHypePopUp() {
      try {
        this.toggleBusy();
        const response = await General.getHypePopUp('type=all&participation=1')
        this.tableData = response.data.popups
        this.totalRows = this.tableData.length
        this.toggleBusy();
      } catch (error) {
        this.toggleBusy();
        this.error = error.response.data.error ? error.response.data.error : "";
        this.tableData = []
        this.totalRows = 0;
      }
    },
    async fetchGroups() {
      try {
        const response = await Customers.getCustomersGroups()
        const rawGroups = Array.isArray(response?.data?.data) ? response.data.data : []
        this.groups = rawGroups
          .map((group) => ({
            value: group.group_id ?? group.id ?? group.value ?? null,
            text: group.name ?? group.group_name ?? group.text ?? '',
          }))
          .filter((group) => group.value && group.text)
      } catch (error) {
        this.groups = []
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    deleteHypePopUp(id) {
      Swal.fire({
        title: "Delete Giveaway Popup?",
        text: "This Giveaway Popup will be deleted!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Remove!",
      }).then((result) => {
        if (result.value) {
          General.deleteHypePopUp(id)
              .then((response) => {
                const res = response.data ? response.data : false;
                const error = response.data.error ? response.data.error : 'Failed';
                if (res) {
                  this.getHypePopUp()
                  Swal.fire("Remove PopUp", "Giveaway Popup successfully removed!", "success");
                } else {
                  Swal.fire("Fail!", error, "warning");
                }
              })
              .catch(error => {
                this.error = error.response.data.error ? error.response.data.error : "Delete Failed";
                this.failedmsg(this.error)
              })
        }
      });
    },
    isPopupActive(popup) {
      const today = new Date();
      const dateFrom = new Date(popup.date_from);
      const dateTo = new Date(popup.date_to);
      return today >= dateFrom && today <= dateTo;
    },
    showSuccessModal(item) {
      this.successModalData = item?.success_page || null
      this.successModalVisible = true
    },
    closeSuccessModal() {
      this.successModalVisible = false
      this.successModalData = null
    },
    toggleBusy() {
      this.isBusy = !this.isBusy;
    },
    failedmsg(error) {
      Swal.fire("Error!", error, "error");
    },

  },

  middleware: "authentication",
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6 mb-5">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center me-5">
                    Show&nbsp;
                    <b-form-select v-model="perPage" size="sm"
                                   :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                  <a href="javascript:void(0);" class="btn btn-success waves-effect waves-light"
                     @click="modalAddHypePopUp">
                    <i class="mdi mdi-plus me-2"></i>
                    Add New Giveaway Popup
                  </a>
                </div>

              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                                  class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="row">
              <div class="col-sm-12">

                <div class="table-responsive mb-0">
                  <b-table :busy="isBusy" :items="tableData" :fields="fields" responsive="sm"
                           :per-page="perPage" :current-page="currentPage" :sort-by.sync="sortBy"
                           :sort-desc.sync="sortDesc" :filter="filter" :filter-included-fields="filterOn"
                           show-empty empty-text="No Data Found" @filtered="onFiltered">

                    <template v-slot:cell(action)="data">
                      <a v-if="data.item.action" :href="data.item.action" target="_blank">Link</a>
                    </template>
                    <!--                                        {{ data.item.action.slice(0,-->
                    <!--                                        50)}}-->

                    <template v-slot:cell(background_image)="data">
                      <div class="flex-shrink-0">
                        <img class="img-fluid table-images" :src="data.item.background_image" width="50">
                      </div>
                    </template>
                    <template   v-slot:cell(participation_tnc_url)="data">
                      <a v-if="data.item.participation_tnc_url"  :href="data.item.participation_tnc_url">Link</a>
                    </template>
                    <template v-slot:cell(date_from)="data">
                                            <span :style="{ color: isPopupActive(data.item) ? 'green' : 'red' }">
                                                {{ data.value }}
                                            </span>
                    </template>
                    <template v-slot:cell(date_to)="data">
                                            <span :style="{ color: isPopupActive(data.item) ? 'green' : 'red' }">
                                                {{ data.value }}
                                            </span>
                    </template>
                    <template v-slot:cell(success_page)="data">
                      <b-button
                        v-if="data.item.success_page"
                        variant="link"
                        class="p-0 text-primary"
                        @click="showSuccessModal(data.item)"
                        title="View success page"
                      >
                        <i class="uil uil-file-alt font-size-18"></i>
                      </b-button>
                      <span v-else class="text-muted">—</span>
                    </template>
                    <template v-slot:cell(actions)="data">
                      <ul class="list-inline mb-0" style="display: flex; flex-wrap: nowrap; align-items: center;">
                        <!--                                                This isn't being used right now-->
                        <!--                                               <li class="list-inline-item">-->
                        <!--                                                    <a href="javascript:void(0);" class="px-2 text-primary"-->
                        <!--                                                        v-b-tooltip.hover title="Images"-->
                        <!--                                                        @click="callmodalHypePopUpPhotos(data.item)">-->
                        <!--                                                        <i class="uil uil-image font-size-18"></i>-->
                        <!--                                                    </a>-->
                        <!--                                                </li>-->
                        <li class="list-inline-item" style="display: inline-block; white-space: nowrap;">
                          <a href="javascript:void(0);" class="px-2 text-info"
                             title="Preview"
                             @click="callModalPreviewGiveawayPopup(data.item)">
                            <i class="uil uil-eye font-size-18"></i>
                          </a>
                        </li>
                        <li class="list-inline-item" style="display: inline-block; white-space: nowrap;">
                          <a href="javascript:void(0);" class="px-2 text-primary"
                             title="Edit"
                             @click="callModalEditGiveawayPopup(data.item)">
                            <i class="uil uil-pen font-size-18"></i>
                          </a>
                        </li>
                        <li class="list-inline-item" style="display: inline-block; white-space: nowrap;">
                          <a href="javascript:void(0);" class="px-2 text-danger"
                             title="Remove"
                             @click="deleteHypePopUp(data.item.id)">
                            <i class="uil uil-trash-alt font-size-18"></i>
                          </a>
                        </li>
                        <li v-if="data.item.type == 'participation'" class="list-inline-item" style="display: inline-block; white-space: nowrap;">
                          <a :href="`/app/popup/${data.item.id}`" class="px-2 text-success"
                             title="View">
                            <i class="uil uil-external-link-alt font-size-18"></i>
                          </a>
                        </li>
                      </ul>
                    </template>

                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                    </template>

                  </b-table>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="totalRows"
                                  :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

      <b-modal
        v-model="successModalVisible"
        title="Success Page Details"
        hide-footer
        centered
        size="lg"
        @hidden="closeSuccessModal"
      >
        <div v-if="successModalData" class="success-modal">
          <div class="mb-3">
            <h5 class="mb-1">Title</h5>
            <p class="mb-0">{{ successModalData.page_popup_title }}</p>
          </div>
          <div class="mb-3">
            <h5 class="mb-1">Description</h5>
            <p class="mb-0">{{ successModalData.page_popup_description }}</p>
          </div>
          <div class="mb-3">
            <h5 class="mb-1">Button Text</h5>
            <p class="mb-0">{{ successModalData.button_cta_text }}</p>
          </div>
          <div class="mb-0">
            <h5 class="mb-1">Button URL</h5>
            <p v-if="successModalData.button_landing_url" class="mb-0">
              <a :href="successModalData.button_landing_url" target="_blank" rel="noopener">
                {{ successModalData.button_landing_url }}
              </a>
            </p>
            <p v-else class="mb-0 text-muted">No URL provided</p>
          </div>
        </div>
        <div v-else class="text-muted">
          No success page data available for this popup.
        </div>
      </b-modal>


    <!-- MODALS -->
    <modalAddGiveawayPopup
      @onRefresh="getHypePopUp"
      :group-options="groups"
    ></modalAddGiveawayPopup>
    <modalEditGiveawayPopup
      @onRefresh="getHypePopUp"
      :popupsData="modalData"
      :groupOptions="groups"
    ></modalEditGiveawayPopup>
    <modalHypePopUpPhotos @onRefresh="getHypePopUp"  :popupsData="modalData"></modalHypePopUpPhotos>
    <modalPreviewGiveawayPopup :popupsData="modalData"></modalPreviewGiveawayPopup>
    <!-- /MODALS -->

  </Layout>
</template>
